module.exports = __webpack_public_path__ + "img/full4-min.6e200c78.png";